/**
 * Returns color classes based on post status
 * @param {string} status - The post status (approved, published, pending, draft)
 * @param {string} view - The calendar view type (dayGridMonth, timeGridWeek)
 * @returns {object} Object containing background and border color classes/values
 */
export const returnStatusColor = (status) => {
  const colors = {
    approved: {
      bg: 'bg-blue-50',
      border: 'border-blue-500',
      solid: '#3b82f6',
      solidBorder: '#2563eb',
    },
    published: {
      bg: 'bg-green-50',
      border: 'border-green-500',
      solid: '#10b981',
      solidBorder: '#059669',
    },
    pending: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-500',
      solid: '#f59e0b',
      solidBorder: '#d97706',
    },
    draft: {
      bg: 'bg-gray-50',
      border: 'border-gray-500',
      solid: '#6b7280',
      solidBorder: '#4b5563',
    },
  };

  const statusColors = colors[status] || colors.draft;

  return {
    className: `${statusColors.bg} border-l-4 ${statusColors.border}`,
    backgroundColor: statusColors.bg,
    borderColor: statusColors.solidBorder,
  };
};
